export default {
    name: 'Jméno',
    tel: 'Telefon',
    save: 'Uložit',
    confirm: 'Potvrdit',
    cancel: 'Zrušit',
    delete: 'Smazat',
    complete: 'Dokončit',
    loading: 'Načítání...',
    telEmpty: 'Vyplňte prosím telefon',
    nameEmpty: 'Vyplňte prosím jméno',
    nameInvalid: 'Neplatné jméno',
    confirmDelete: 'Opravdu chcete smazat?',
    telInvalid: 'Neplatné telefonní číslo',
    vanCalendar: {
        end: 'Konec',
        start: 'Začátek',
        title: 'Kalendář',
        startEnd: 'Začátek/Konec',
        weekdays: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Vyberte maximálně ${maxRange} dní`,
    },
    vanCascader: {
        select: 'Vybrat',
    },
    vanContactCard: {
        addText: 'Přidat kontaktní informace',
    },
    vanContactList: {
        addText: 'Přidat nový kontakt',
    },
    vanPagination: {
        prev: 'Předchozí',
        next: 'Další',
    },
    vanPullRefresh: {
        pulling: 'Stáhněte pro obnovení...',
        loosing: 'Pusťte pro obnovení...',
    },
    vanSubmitBar: {
        label: 'Celkem：',
    },
    vanCoupon: {
        unlimited: 'Neomezeno',
        discount: (discount) => `${discount * 10}% sleva`,
        condition: (condition) => `Minimálně ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupón',
        tips: 'Žádné kupóny',
        count: (count) => {
            if (count === 1) return 'Máte 1 kupón';
            if (count >= 2 && count <= 4) return `Máte ${count} kupóny`;
            return `Máte ${count} kupónů`;
        },
    },
    vanCouponList: {
        empty: 'Žádné kupóny',
        exchange: 'Vyměnit',
        close: 'Zavřít',
        enable: 'Dostupné',
        disabled: 'Nedostupné',
        placeholder: 'Kód kupónu',
    },
    vanAddressEdit: {
        area: 'Oblast',
        postal: 'PSČ',
        areaEmpty: 'Vyberte prosím doručovací oblast',
        addressEmpty: 'Adresa nemůže být prázdná',
        postalEmpty: 'Neplatné PSČ',
        defaultAddress: 'Nastavit jako výchozí adresu',
        telPlaceholder: 'Telefon',
        namePlaceholder: 'Jméno',
        areaPlaceholder: 'Oblast',
    },
    vanAddressEditDetail: {
        label: 'Adresa',
        placeholder: 'Adresa',
    },
    vanAddressList: {
        add: 'Přidat novou adresu',
    },
};